import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { SampleOrderContent } from '../../components/SampleOrderContent/SampleOrderContent';

const StepperItem = () => (
  <div className="flex flex-row gap-2">
    <Skeleton className="h-2 w-2 rounded-full" />
    <Skeleton className="h-2 w-2/3" />
  </div>
);

export const SampleOrderSuspenseFallback = () => (
  <div className="flex h-full w-full overflow-hidden">
    <div className="flex w-full flex-row overflow-hidden">
      {/* Non Mobile Stepper */}
      <div className="bg-color-background-base hidden shrink-0 grow-0 basis-1/3 md:block">
        <div className="flex flex-col gap-6 px-3 pt-6">
          <StepperItem />
          <StepperItem />
          <StepperItem />
        </div>
      </div>
      <div className="flex h-full shrink grow basis-0 flex-col md:basis-2/3">
        {/* Mobile Stepper */}
        <div className="bg-color-background-base md:hidden">
          <div className="flex flex-col gap-2">
            <div className="flex flex-row justify-between">
              <Skeleton className="h-3 w-3 rounded-full" />
              <Skeleton className="h-3 w-3 rounded-full" />
              <Skeleton className="h-3 w-3 rounded-full" />
            </div>
            <Skeleton className="mb-4 h-2 w-full" />
          </div>
        </div>
        <div className="h-full shrink grow basis-0">
          <SampleOrderContent
            pageContent={
              <div className="flex flex-col gap-2">
                <Skeleton className="h-[160px] w-full" />
                <Skeleton className="h-[160px] w-full" />
                <Skeleton className="h-[160px] w-full" />
              </div>
            }
            actionBarContent={
              <div className="flex w-full flex-row items-center justify-end gap-1 p-2">
                <Skeleton className="h-2 w-2/5" />
                <Skeleton className="h-3 w-2/5" />
              </div>
            }
          />
        </div>
      </div>
    </div>
  </div>
);
